import axios from 'axios';
import { getClinicsApiBaseURL } from '../utils/apiConfig';

export const CLINICS_TOKEN_KEY = 'clinics_token';
export const SELECTED_CLINICA_KEY = 'clinics_selected_clinica_id';

export const getAuthToken = (): string | null => {
  return localStorage.getItem(CLINICS_TOKEN_KEY);
};

export const setAuthToken = (token: string | null): void => {
  if (token) {
    localStorage.setItem(CLINICS_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(CLINICS_TOKEN_KEY);
  }
};

export const getSelectedClinicaId = (): number | null => {
  const val = localStorage.getItem(SELECTED_CLINICA_KEY);
  return val ? parseInt(val, 10) : null;
};

export const setSelectedClinicaId = (clinicaId: number | null): void => {
  if (clinicaId) {
    localStorage.setItem(SELECTED_CLINICA_KEY, String(clinicaId));
  } else {
    localStorage.removeItem(SELECTED_CLINICA_KEY);
  }
};

const api = axios.create({
  baseURL: getClinicsApiBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para injetar Bearer token e clínica selecionada em rotas autenticadas
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['x-forwarded-authorization'] = `Bearer ${token}`;
  }
  const selectedClinicaId = getSelectedClinicaId();
  if (selectedClinicaId) {
    config.headers['x-clinica-id'] = String(selectedClinicaId);
  }
  return config;
});

// Interceptor para tratar expiração de sessão (401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Se não for rota de tentativa de login/autenticação inicial, limpar token
      if (
        !url.includes('/auth/login') &&
        !url.includes('/auth/medico/login') &&
        !url.includes('/auth/solicitar-acesso')
      ) {
        setAuthToken(null);
        window.dispatchEvent(new CustomEvent('clinics:unauthorized'));
      }
    }
    return Promise.reject(error);
  },
);

export default api;
